import fleetApi from "@/lib/fleetApi";
import { dayKey, todayKey } from "@/lib/time";
import { pausedDriverIds } from "@/lib/pausedDrivers";

// Fleet plans one day at a time (defaults to today), so plan each pickup day separately and merge.
export async function planByDay(tripIds, tripsById, extra = {}) {
  const groups = {};
  (tripIds || []).forEach((id) => {
    const day = dayKey(tripsById?.[id]?.scheduled_pickup) || todayKey();
    (groups[day] = groups[day] || []).push(id);
  });
  const days = Object.keys(groups).sort();
  if (!days.length) return { assignments: [], unassignable: [], summary: "No trips to plan." };
  const paused = await pausedDriverIds();
  const parts = await Promise.all(days.map((d) => fleetApi.post("/trips/assign-plan", { trip_ids: groups[d], date: d, ...extra }).then((r) => r.data)));
  const all = parts.flatMap((p) => p.assignments || []);
  const assignments = all.filter((a) => !paused.has(a.driver_id));
  const benched = all.filter((a) => paused.has(a.driver_id)).map((a) => ({ trip_id: a.trip_id, reason: `${a.driver_name || "Best match"} is marked inactive — pick another driver` }));
  return {
    ...parts[0],
    assignments,
    unassignable: [...parts.flatMap((p) => p.unassignable || []), ...benched],
    date: days.length === 1 ? days[0] : null,
    summary: days.length === 1 && !benched.length ? parts[0].summary : `${assignments.length} trip${assignments.length === 1 ? "" : "s"} matched to drivers${days.length > 1 ? ` across ${days.length} days` : ""}.`,
  };
}
